<template>
    <div class="box">
        <a-spin :spinning="spinning">
            <a-form-model
                    ref="ruleForm"
                    :model="form"
                    :rules="rules"
                    :label-col="labelCol"
                    :wrapper-col="wrapperCol"
                    :colon="false"
            >
                <a-form-model-item ref="seo_title" label="SEO标题" prop="seo_title" :extra="formErr.seo_title"  :validateStatus='!formErr.seo_title||formErr.seo_title==""?"":"error"'>
                    <a-input :addonAfter="showNum( 'seo_title')+'/110'" v-model="form.seo_title"   @change="(e) => { formErr.seo_title='';changetaba=2}" @blur="(e) => {  form.seo_title = e.target.value.trim() }" :maxLength=110 />

                </a-form-model-item>
                <a-form-model-item ref="seo_keywords" label="SEO关键字" prop="seo_keywords" :extra="formErr.seo_keywords"  :validateStatus='!formErr.seo_keywords||formErr.seo_keywords==""?"":"error"'>
                    <a-input :addonAfter="showNum( 'seo_keywords')+'/200'" v-model="form.seo_keywords" @change="(e) => { formErr.seo_keywords='';changetaba=2}" @blur="(e) => {  form.seo_keywords = e.target.value.trim() }" :maxLength=200 />
                </a-form-model-item>
                <a-form-model-item
                        ref="seo_description"
                        label="SEO描述"
                        prop="seo_description"
                        :extra="formErr.seo_description"
                        :validateStatus='!formErr.seo_description||formErr.seo_description==""?"":"error"'
                >
                    <a-textarea   :rows="5" v-model="form.seo_description"  :maxLength=400   class="textareas"
                                  @change="(e) => { formErr.seo_description='';changetaba=2}"
                                  @blur="(e) => {  form.seo_description = e.target.value.trim() }" />
                    <span class="suffixStyle">{{showNum('seo_description')+'/400'}}</span>
                </a-form-model-item>
                <a-form-model-item   label=" ">
                    <a-button type="primary" @click="onSubmit">
                        确认
                    </a-button>
<!--                    <a-button style="margin-left: 10px;" @click="resetForm">-->
<!--                        Reset-->
<!--                    </a-button>-->
                </a-form-model-item>
            </a-form-model>
        </a-spin>
    </div>

</template>

<script>
    import {submitForm} from '../../../../utils/utils';
    import API from "../api"
    export default {
        name: "seoForm",
        props: ["changeTabs"],
        data() {
            return {
                changetaba:1,
                spinning: true ,
                formErr: { seo_title: "", seo_keywords: "" ,seo_description:""},
                labelCol: { span: 4 },
                wrapperCol: { span: 14 },
                other: '',
                form:{ seo_title: "", seo_keywords: "" ,seo_description:""},
                rules: {
                    site_url: [
                        { required: true, message: 'Please input Activity name', trigger: 'blur' },
                    ],
                    site_name: [{ required: true, message: 'Please select Activity zone', trigger: 'change' }],
                    site_admin_email: [  { type: 'email', message: 'E-mail!', trigger: 'blur' } ],
                },
            };
        },

        mounted() {
         this.getFormData()

        },
        computed:{
            showNum() {
                return function(value) {
                    return this.form[value].length
                }
            }
        },
        watch:{
            changeTabs: function (a, b) {
                let _this=this
                if (a == 2) {  }
            }
        },
        methods: {
            checkVal(){
                this.onSubmit()
                this.changetab=1
            },
            getFormData() {
                API.WebsiteInformation.GET_WEBSITE().then(res => {
                   let  { seo_title , seo_keywords ,seo_description }  = res.data.data
                    this.form.seo_title=seo_title
                    this.form.seo_keywords=seo_keywords
                    this.form.seo_description=seo_description
                    this.spinning = false;
                })
                this.changetaba=1
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        submitForm(API.WebsiteInformation.SET_SITEINFO, {type:2,...this.form}).then(res=>{
                            if (res == true) {
                                this.getFormData()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                        this.getFormData()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            resetForm() {
                this.$refs.ruleForm.resetFields();
            },
        },
    }
</script>

<style scoped>
    .suffixStyle{position: relative;
        top: -25px;
        left: 1px;
        display: block;
        width:calc( 100% - 2px);
        line-height: 20px;
        text-align: right;
        background-color: #fff;
        padding-right: 10px;

    }
    .box >>> .textareas{padding-bottom:30px!important;}
    /* .box >>> .ant-input-group-addon{background-color: #fff!important;border-left: 1px solid #fff!important;
        }
         .box >>> .ant-input{border-right: 1px solid #fff!important} */
</style>